module.exports = __webpack_public_path__ + "img/icon-free-blue.8c331431.png";